/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Staff_SigninInputs */

const th_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อดูผู้ฝึกสอนของทีมนี้`)
};

const en_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to see who coaches this team.`)
};

const ja_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチームのコーチを見るにはサインインしてください。`)
};

const zh_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可查看这支球队由谁执教。`)
};

const es_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para ver quién entrena a este equipo.`)
};

const pt_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para ver quem treina este time.`)
};

const id_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk melihat siapa yang melatih tim ini.`)
};

const fr_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour voir qui entraîne cette équipe.`)
};

const tl_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para makita kung sino ang nagko-coach sa team na ito.`)
};

const vi_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để xem ai dẫn dắt đội này.`)
};

const ko_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 팀을 누가 지도하는지 보려면 로그인하세요.`)
};

const de_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um zu sehen, wer dieses Team trainiert.`)
};

const ru_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы увидеть, кто тренирует эту команду.`)
};

const tr_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu takımı kimin çalıştırdığını görmek için giriş yapın.`)
};

const it_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per vedere chi allena questa squadra.`)
};

const pl_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby zobaczyć, kto prowadzi tę drużynę.`)
};

const uk_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб побачити, хто тренує цю команду.`)
};

const hi_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह देखने के लिए साइन इन करें कि इस टीम को कौन प्रशिक्षित करता है।`)
};

const ar_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لترى من يدرّب هذا الفريق.`)
};

const ms_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk melihat siapa melatih pasukan ini.`)
};

const bn_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই দলকে কে প্রশিক্ষণ দেন তা দেখতে সাইন ইন করুন।`)
};

const zh_tw2_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看這支球隊由誰執教。`)
};

const zh_hk2_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看這支球隊由誰執教。`)
};

const ur_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ دیکھنے کے لیے سائن اِن کریں کہ اس ٹیم کو کون تربیت دیتا ہے۔`)
};

const fa_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دیدن اینکه چه کسی این تیم را تمرین می‌دهد وارد شوید.`)
};

const sw_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kuona nani anaifunza timu hii.`)
};

const nl_coaching_staff_signin = /** @type {(inputs: Coaching_Staff_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om te zien wie dit team traint.`)
};

/**
* | output |
* | --- |
* | "Sign in to see who coaches this team." |
*
* @param {Coaching_Staff_SigninInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const coaching_staff_signin = /** @type {((inputs?: Coaching_Staff_SigninInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Staff_SigninInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_coaching_staff_signin(inputs)
	if (locale === "ja") return ja_coaching_staff_signin(inputs)
	if (locale === "zh") return zh_coaching_staff_signin(inputs)
	if (locale === "es") return es_coaching_staff_signin(inputs)
	if (locale === "pt") return pt_coaching_staff_signin(inputs)
	if (locale === "id") return id_coaching_staff_signin(inputs)
	if (locale === "fr") return fr_coaching_staff_signin(inputs)
	if (locale === "tl") return tl_coaching_staff_signin(inputs)
	if (locale === "vi") return vi_coaching_staff_signin(inputs)
	if (locale === "ko") return ko_coaching_staff_signin(inputs)
	if (locale === "de") return de_coaching_staff_signin(inputs)
	if (locale === "ru") return ru_coaching_staff_signin(inputs)
	if (locale === "tr") return tr_coaching_staff_signin(inputs)
	if (locale === "it") return it_coaching_staff_signin(inputs)
	if (locale === "pl") return pl_coaching_staff_signin(inputs)
	if (locale === "uk") return uk_coaching_staff_signin(inputs)
	if (locale === "hi") return hi_coaching_staff_signin(inputs)
	if (locale === "ar") return ar_coaching_staff_signin(inputs)
	if (locale === "ms") return ms_coaching_staff_signin(inputs)
	if (locale === "bn") return bn_coaching_staff_signin(inputs)
	if (locale === "zh-TW") return zh_tw2_coaching_staff_signin(inputs)
	if (locale === "zh-HK") return zh_hk2_coaching_staff_signin(inputs)
	if (locale === "ur") return ur_coaching_staff_signin(inputs)
	if (locale === "fa") return fa_coaching_staff_signin(inputs)
	if (locale === "sw") return sw_coaching_staff_signin(inputs)
	if (locale === "nl") return nl_coaching_staff_signin(inputs)
	return en_coaching_staff_signin(inputs)
});